<p-toast position="top-right"></p-toast>
<app-loading *ngIf="isLoading"></app-loading>
<div *ngIf="!isLoading" class="parent-container">
  <div [ngClass]="{ customer: isCustomer, customerLink: !isCustomer }">
    <div>
      <div class="modal-content mt-receipt">
        <div class="modal-header">
          <div ngbDropdown *ngIf="!commonService.isMobileView">
            <button style="float:right;color:white;" class="btn btn-primary btn_align" id="dropdownMenuActiveItem"
              ngbDropdownToggle> Actions</button>
            <div class="list_fixed" ngbDropdownMenu aria-labelledby="dropdownMenuActiveItem">
              <button ngbDropdownItem (click)="download('png')"><i class="link-icon feather icon-image"></i>
                PNG</button>
              <button ngbDropdownItem class="print" (click)="printPage()"><span class="mdi mdi-printer" aria-hidden></span>
                Print/PDF</button>
                <button ngbDropdownItem (click)="emailPopupModal()"><span class="mdi mdi-email-outline" aria-hidden></span> Email</button>
            
              </div>
          </div>
          <!-- <button type="button" class="close" (click)="closeModal('closeByIcon')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>  -->

 <button type="button" class="close" (click)="modal.close('by: close icon')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        </div>

        <div class="customer-link">
          <div ngbDropdown class="pt-4" [ngClass]="commonService.isMobileView ? 'mb-5 mr-5' : ''">
            <button style="float:right;" class="btn btn-outline-primary btn_align" id="dropdownMenuActiveItem"
              ngbDropdownToggle> Actions</button>
            <div class="list_fixed" ngbDropdownMenu aria-labelledby="dropdownMenuActiveItem">
              <button ngbDropdownItem (click)="download('png')"><i class="link-icon feather icon-image"></i>
                PNG</button>
                <button ngbDropdownItem class="print" (click)="printPage()"><span class="mdi mdi-printer" aria-hidden></span>
                  Print/PDF </button>
                    
            </div>
          </div>
        </div>

        <div id="showScroll" class="container">
          <div class="receipt" [ngClass]="isCustomer ? 'view-from-transaction' : 'view-standalone'" #screen>
            <section *ngIf="!isItemsList">
            
              <div *ngIf="logo" class="logo"><img class="logo_align" [src]="logo" alt="MERCHANTLOGO"></div>
              <div class="address">
                <p class="center_add">{{receiptData?.receiptDetails?.h1}}</p>
                <p class="center_add">{{receiptData?.receiptDetails?.h2}}</p>
                <p class="center_add">{{receiptData?.receiptDetails?.h3}}</p>
                <p class="center_add">{{receiptData?.receiptDetails?.h4}}</p>
                <p class="center_add">{{receiptData?.receiptDetails?.h5}}</p>
                <p class="center_add">{{receiptData?.receiptDetails?.h6}}</p>
                <p class="center_add"></p>
                <p class="center_add"></p>
              </div>
              <div class="transactionDetails">
                <div class="detail">{{errorHandle(receiptData?.txnDetails?.posRequestDate | momentDate)}}</div>
                <div class="detail"></div>
                <div class="detail">{{errorHandle(timeSub(receiptData?.txnDetails?.posRequestTime))}}</div>
              </div>
              <div class="detail m-2" *ngIf="receiptData?.signatureDetails?.customField?.signature?.ipAddress">IP: {{receiptData?.signatureDetails?.customField?.signature?.ipAddress}}</div>
                      <div class="transactionDetails pb-2" *ngIf="receiptType=='Merchant Copy'">
                        <div>{{'parameter.tpn' | translate}}:</div>
                        <div>{{errorHandle(receiptData?.txnDetails?.tpn)}}</div>
                      </div>
                      <div class="transactionDetails" *ngIf="isCheckTrans">
                        <div class="checkDetail">{{'htmlText.trans' | translate}} #: {{receiptData?.txnDetails?.rrn}}</div>
                        <div class="checkDetail"></div>
                        <div class="checkDetail">{{'htmlText.batch' | translate}} #: {{receiptData?.txnDetails?.tpnBatchNumber }}
                        </div>
                      </div>
              <!-- commenting based on ios/top -->
              <!-- <div class="survey bold" *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone'">
                <p class="txt_size_txname">{{receiptData?.signatureDetails?.customField?.paymentType}}</p>
              </div> -->
              <!-- testing -->
            
              <div class="survey bold margin-top-bottom"
                *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && isNotCheckTrans">
                <p class="txt_size_txname">{{receiptData?.txnDetails?.voidFlag == 'Y' ? ('label.voided' | translate) : '' }}
                  {{getTxName(receiptData?.txnDetails?.txName ,
                  receiptData?.txnDetails?.transactionType)}}</p>
              </div>
              <div class="survey bold margin-top-bottom" *ngIf="isCheckTrans">
                <p class="txt_size_txname">{{'htmlText.conversion' | translate}}</p>
              </div>
            
              <div class="transactionDetails" *ngIf="receiptData?.txnDetails.transactionType == 'CASH'">
                <div class="detail">{{'htmlText.type' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.txnDetails.transactionType}}</div>
              </div>

              <div class="transactionDetails" *ngIf="receiptData?.txnDetails.transactionType != 'WALLET' && isNotCheckTrans">
                <div class="detail" *ngIf="receiptData?.txnDetails.transactionType != 'CASH'">{{'htmlText.trans' |
                  translate}} #: {{get(receiptData?.txnDetails?.invoiceNumber, receiptData?.txnDetails?.voidFlag) |
                  number}}</div>
                <div class="detail" *ngIf="receiptData?.txnDetails.transactionType == 'CASH'">{{'htmlText.trans' |
                  translate}} #: {{receiptData?.txnDetails?.rrn}}</div>
                <div class="detail"></div>
                <div class="detail">{{'htmlText.batch' | translate}} #: {{receiptData?.txnDetails?.tpnBatchNumber }}
                </div>
              </div>
            
              <!-- testing -->
            
              <div class="transactionCardName"
                *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET'">
                <div class="detail" *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone'">
                  {{cardLabel(receiptData?.txnDetails?.cardLabel, receiptData?.txnDetails?.transactionType)}}</div>
                <div class="detail"></div>
                <div class="detail"></div>
              </div>
            
              <div class="transactionCardName"
                *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET' && isNotCheckTrans">
                <div class="detail" *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone'">
                  {{receiptData?.signatureDetails?.customField?.entryLegend}}</div>
                <div class="detail" *ngIf="receiptData?.signatureDetails?.customField?.posType != 'TapOnPhone'">
                  {{cardLabel(receiptData?.txnDetails?.cardLabel, receiptData?.txnDetails?.transactionType)}}</div>
                <div class="detail"></div>
                <div class="detail">{{transMode(receiptData?.txnDetails?.posEntryMode)}}</div>
              </div>
            
              <!-- testing -->
            
            
              <!-- <div class="transactionCardName" *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET'">
                      <div class="detail">{{cardLabel(receiptData?.txnDetails?.cardLabel, receiptData?.txnDetails?.transactionType)}}</div>
                      <div class="detail"></div>
                      <div class="detail" *ngIf="receiptData?.txnDetails?.txName != 'TICKET'" >{{transMode(receiptData?.txnDetails?.posEntryMode)}}</div>
                      <div class="detail" *ngIf="receiptData?.txnDetails?.txName == 'TICKET'" >{{'htmlText.manual' | translate}}</div>
                    </div> -->
            
            
              <div class="transactionDetails"
                *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET' && isNotCheckTrans">
                <div class="detail">{{showMaskedCardNum(receiptData?.txnDetails?.maskedPan)}}</div>
                <div class="detail"></div>
                <div class="detail" *ngIf="receiptData?.txnDetails.transactionType != transactionDetails.check">**/**</div>
                <div class="detail" *ngIf="receiptData?.txnDetails.transactionType == transactionDetails.check">
                  {{receiptData?.signatureDetails?.customField?.checkNumber}}</div>
              </div>

              <div *ngIf="receiptData?.txnDetails.L2L3uploadflag && (receiptData?.valAdd?.LEVEL_TAX_PRINT == 1 && receiptData?.valAdd?.L2_L3_DATA == 1) && receiptType=='Merchant Copy'">
                <div class="transactionDetails my-1" *ngIf="receiptData?.txnDetails.L2L3uploadflag != 'E' else noTaxReported">
                  <span> Tax Reported: </span> <span> {{ (receiptData?.txnDetails.localTaxAmount +
                    receiptData?.txnDetails.stateTaxAmount || receiptData?.txnDetails.commercialTaxAmount) | toAmount | currency }}
                  </span>
                </div>
                <ng-template #noTaxReported>
                  <div class="my-1 text-center">
                    L2L3 not processed
                  </div>
                </ng-template>
              </div>
              <div class="survey bold"
                *ngIf="receiptData?.txnDetails.transactionType == 'CASH' || receiptData?.txnDetails.transactionType == 'GIFT' || receiptData?.txnDetails.transactionType == 'LOYALTY'">
                <p class="txt_size_txname">{{txHandle(receiptData?.txnDetails?.txName)}}</p>
              </div>
            
            
              <div class="transactionDetails" *ngIf="(receiptData?.txnDetails.transactionType == 'EBT')">
                <div class="detail">{{'htmlText.trace' | translate}} #:</div>
                <div class="detail"></div>
                <div class="detail">{{get(receiptData?.txnDetails?.invoiceNumber,
                  receiptData?.txnDetails?.voidFlag) | number}}</div>
              </div>
            
              <div class="transactionDetails" *ngIf="(receiptData?.txnDetails.transactionType == 'EBT')">
                <div class="detail">{{'htmlText.benefit' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{ebt_type(receiptData?.txnDetails?.transactionType,
                  receiptData?.txnDetails?.processingCode)}}</div>
              </div>
            
              <div class="transactionDetails" *ngIf="receiptData?.txnDetails.transactionType == 'WALLET'">
                <div class="detail">{{receiptData?.txnDetails?.sourceType}}:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.txnDetails?.transactionType}}</div>
              </div>
            
              <div class="transactionDetails mar_top_acct"
                *ngIf="(receiptData?.txnDetails.transactionType == 'GIFT' || receiptData?.txnDetails.transactionType == 'LOYALTY') && receiptData?.txnDetails.txName == 'TRANSFER'">
                <div class="detail">{{'htmlText.oldAcct' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{showMaskedCardNum(receiptData?.txnDetails?.cardHolderName)}}</div>
              </div>
              <div class="transactionDetails" [ngClass]="receiptData?.txnDetails.txName != 'TRANSFER'?'mar_top_acct':''"
                *ngIf="receiptData?.txnDetails.transactionType == 'GIFT' || receiptData?.txnDetails.transactionType == 'LOYALTY'">
                <div class="detail">{{(receiptData?.txnDetails.txName == 'TRANSFER'? 'htmlText.newAcct':
                  'htmlText.acct') | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{showMaskedCardNum(receiptData?.txnDetails?.maskedPan)}}</div>
              </div>
            
              <div class="transactionDetails"
                *ngIf="receiptData?.txnDetails.transactionType == 'GIFT' || receiptData?.txnDetails.transactionType == 'LOYALTY' || isCheckTrans">
                <div [ngClass]="isCheckTrans ? 'checkDetail' : 'detail'">{{'htmlText.type' | translate}}:</div>
                <div class="detail"></div>
                <div [ngClass]="isCheckTrans ? 'checkDetail' : 'detail'">{{receiptData?.txnDetails.transactionType}}</div>
              </div>
            
              <div class="transactionDetails"
                *ngIf="receiptData?.txnDetails.transactionType == 'GIFT' || receiptData?.txnDetails.transactionType == 'LOYALTY'|| isCheckTrans">
                <div [ngClass]="isCheckTrans ? 'checkDetail' : 'detail'">{{'htmlText.entry' | translate}}:</div>
                <div class="detail"></div>
                <div [ngClass]="isCheckTrans ? 'checkDetail' : 'detail'">{{transMode(receiptData?.txnDetails?.posEntryMode)}}</div>
              </div>

              <div class="transactionDetails" *ngIf="isCheckTrans">
                <div class="checkDetail">{{'htmlText.routing'  | translate}} #:</div>
                <div class="checkDetail"></div>
                <div class="checkDetail">****</div>
              </div>
    
              <div class="transactionDetails" *ngIf="isCheckTrans">
                <div class="checkDetail">{{'htmlText.account'  | translate}} #:</div>
                <div class="checkDetail"></div>
                <div class="checkDetail">****</div>
              </div>
              
              <div class="transactionDetails" *ngIf="isCheckTrans">
                <div class="checkDetail">{{'htmlText.check'  | translate}} #:</div>
                <div class="checkDetail"></div>
                <div class="checkDetail"></div>
              </div>
            
              <div class="transactionDetails"
                *ngIf="receiptData?.txnDetails.transactionType == 'GIFT' || receiptData?.txnDetails.transactionType == 'LOYALTY'">
                <div class="detail">{{'htmlText.service' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.txnDetails?.txName}}</div>
              </div>
            
              <div class="paymentDetails bold" *ngIf="receiptData?.txnDetails.transactionType == 'LOYALTY'">
                <div class="detail">{{'htmlText.points' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.txnDetails?.totalAmount}}</div>
              </div>
              <section class="p-2" *ngIf="isInvoice">
                <hr class="my-1">
                <div *ngFor="let item of lineItemsArray" class="justify-content-between d-flex align-items-end"
                  style="font-size: small;">
                  <div class="d-flex flex-column"> <span> {{item.productName}} </span> <span> {{item.quantity}} X
                      {{item.unitCost | toAmount : false}} </span>
                  </div>
                  <span>
                    {{item.totalBaseAmountWithoutDiscount
                    | toDollars}} </span>
                </div>
              
              </section>

              <div class="paymentDetails bold " *ngIf="itemizedDetails.shippingFee">
                <div class="detail">{{'Shipping Fee' | translate}}</div>
                <div class="detail"></div>
                <div class="detail">{{itemizedDetails.shippingFee | toDollars}}</div>
              
              </div>

              <div class="paymentDetails bold " *ngIf="(itemizedDetails.totalBaseAmount) else baseAmt ">
                <div class="detail">{{baseAmtLabel | translate}}</div>
                <div class="detail"></div>
                <div class="detail">{{ ((receiptData?.txnDetails?.hostResponseCode == "10" ||
                  receiptData?.txnDetails?.hostResponseCode== "002") ? receiptData?.txnDetails?.approvedAmount:
                  receiptData?.txnDetails?.txAmount + receiptData?.txnDetails?.TxAmountFee + itemizedDetails.totalDiscount) | toDollars}}
                  </div>
              
              </div>
              <ng-template #baseAmt>
                <div class="paymentDetails bold" *ngIf="showBaseAmountDetails(receiptData?.txnDetails)">
                  <div class="detail">{{baseAmtLabel | translate}}:</div>
                  <div class="detail"></div>
                  <div class="detail">{{transAmount(sumAmount(receiptData?.txnDetails?.preauthFlag == "I" ? receiptData?.txnDetails?.totalAmount : receiptData?.txnDetails?.txAmount,
                    receiptData?.txnDetails?.TxAmountFee)) | currency}}</div>
                </div>
              </ng-template>
              
              <!-- <div class="paymentDetails bold " *ngIf="itemizedDetails.totalTax">
                <div class="detail">Tax Amt:</div>
                <div class="detail"></div>
                <div class="detail">{{itemizedDetails.totalTax | toDollars}}</div>
              </div> -->
              
              
            
              <div *ngIf="(receiptData?.txnDetails.customFee != 0  && receiptData?.txnDetails.customFee != null)"
                class="paymentDetails bold">
                <div class="detail" *ngIf="receiptData?.signatureDetails?.customFeeLabel?.length < 20">
                  {{defaultName(receiptData?.signatureDetails?.customFeeLabel)}}:</div>
                <div class="detail" *ngIf="receiptData?.signatureDetails?.customFeeLabel?.length >= 20" placement="bottom"
                  triggers="mouseenter:mouseleave" container="body" ngbPopover="{{defaultName(receiptData?.signatureDetails?.customFeeLabel)}}">
                  {{defaultName(receiptData?.signatureDetails?.customFeeLabel) | slice:0:17}}...:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.txnDetails?.customFee) | currency}}</div>
              </div>
              <div *ngIf="(receiptData?.txnDetails.serviceFee != 0 && receiptData?.txnDetails.serviceFee != null)"
                class="paymentDetails bold">
                <div class="detail">{{defaultName(receiptData?.signatureDetails?.customFeeLabel)}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.txnDetails?.serviceFee) | currency}}</div>
              </div>
              <div *ngIf="!(['CASH','CREDIT','DEBIT'].indexOf(receiptData?.txnDetails?.transactionType) < 0)">
                <div *ngIf="receiptData?.signatureDetails?.customField?.cashMessageLabel" class="paymentDetails bold">
                  <div class="detail">{{receiptData?.signatureDetails?.customField?.cashMessageLabel}}:</div>
                  <div class="detail"></div>
                  <div class="detail">{{ 0 | currency}}</div>
                </div>
                <div *ngIf="receiptData?.signatureDetails?.customField?.creditMessageLabel" class="paymentDetails bold">
                  <div class="detail">{{receiptData?.signatureDetails?.customField?.creditMessageLabel}}:</div>
                  <div class="detail"></div>
                  <div class="detail">{{ 0 | currency}}</div>
                </div>
              </div>
              <div *ngIf="(receiptData?.txnDetails.surcharge != 0 && receiptData?.txnDetails.surcharge != null) && !(receiptData?.txnDetails.txName == 'PREAUTH' && receiptData?.txnDetails.voidFlag == 'Y')"
                class="paymentDetails bold">
                <div class="detail">{{defaultSCH(receiptData?.signatureDetails?.merchantFeeLabel)}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.txnDetails?.surcharge) | currency}}</div>
              </div>
              <div *ngIf="(receiptData?.txnDetails.merchantFee != 0 && receiptData?.txnDetails.merchantFee != null)"
                class="paymentDetails bold">
                <div class="detail">{{defaultMFL(receiptData?.signatureDetails?.merchantFeeLabel)}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.txnDetails?.merchantFee) | currency}}</div>
              </div>
              <div *ngIf="(receiptData?.feeDetails?.F_TYP == 5 && receiptData?.txnDetails?.TxAmountFee!= 0 && receiptData?.txnDetails?.TxAmountFee != null) && !(receiptData?.txnDetails.txName == 'PREAUTH' && receiptData?.txnDetails.voidFlag == 'Y')"
                class="paymentDetails bold">
                <div class="detail">{{defaultMFL(receiptData?.feeDetails?.RP_DL)}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.txnDetails?.TxAmountFee) | currency}}</div>
              </div>
              <div *ngIf="isShowTax(receiptData?.txnDetails?.localTaxAmount, receiptData?.emvDetails?.HACIENDA_ENABLED, receiptData?.txnDetails?.txName) && !(receiptData?.txnDetails.txName == 'PREAUTH' && receiptData?.txnDetails.voidFlag == 'Y')"
                class="paymentDetails bold">
                <div class="detail">{{defaultLTL(receiptData?.signatureDetails?.localTaxLabel)}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(sumAmount(receiptData?.txnDetails?.localTaxAmount,
                  receiptData?.txnDetails?.LTaxFee)) | currency}}</div>
              </div>
              <div *ngIf="isShowTax(receiptData?.txnDetails?.stateTaxAmount, receiptData?.emvDetails?.HACIENDA_ENABLED, receiptData?.txnDetails?.txName) && !(receiptData?.txnDetails.txName == 'PREAUTH' && receiptData?.txnDetails.voidFlag == 'Y')"
                class="paymentDetails bold">
                <div class="detail">{{defaultSTL(receiptData?.signatureDetails?.stateTaxLabel)}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(sumAmount(receiptData?.txnDetails?.stateTaxAmount,
                  receiptData?.txnDetails?.GTaxFee)) | currency}}</div>
              </div>

              <div *ngIf="isShowTax(receiptData?.txnDetails?.tsysRespData?.reducedTax, receiptData?.emvDetails?.HACIENDA_ENABLED, receiptData?.txnDetails?.txName)" class="paymentDetails bold">
                <div class="detail">{{defaultRTL(receiptData?.signatureDetails?.customField?.reducedTaxLabel)}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(sumAmount(receiptData?.txnDetails?.tsysRespData?.reducedTax, receiptData?.txnDetails?.tsysRespData?.reducedTaxFee)) | currency}}</div>
              </div>
              
              <!-- Disc fee label & value -->
              <div
                *ngIf="((receiptData?.txnDetails.transactionType != 'CREDIT' || receiptData?.txnDetails.transactionType != 'DEBIT') && receiptData?.txnDetails.DiscountFee != 0 && receiptData?.txnDetails.DiscountFee != null && !itemizedDetails.totalDiscount)"
                class="paymentDetails bold">
                <div class="detail">{{'htmlText.disc' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.txnDetails?.DiscountFee, true) | currency}}</div>
              </div>
              <div
                *ngIf="((receiptData?.txnDetails.transactionType == 'CREDIT' || receiptData?.txnDetails.transactionType == 'DEBIT') && receiptData?.txnDetails?.serviceFee > 0 && !itemizedDetails.totalDiscount)"
                class="paymentDetails bold">
                <div class="detail">{{'htmlText.disc' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.txnDetails?.DiscountFee, true) | currency}}</div>
              </div>
              <!-- Disc fee label & value -->
              <div
                *ngIf="((receiptData?.txnDetails.tipAmount != 0 && receiptData?.txnDetails.tipAmount != null) || (receiptData?.txnDetails.tipAdjAmount != 0 && receiptData?.txnDetails.tipAdjAmount != null))"
                class="paymentDetails bold">
                <div class="detail">{{'htmlText.tipAmt' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(sumTip(receiptData?.txnDetails?.tipAmount,
                  receiptData?.txnDetails?.tipAdjAmount, receiptData?.txnDetails?.TipAmountFee)) | currency}}</div>
              </div>
              <div *ngIf="(receiptData?.txnDetails.cashDiscount != 0 && receiptData?.txnDetails.cashDiscount != null)"
                class="paymentDetails bold">
                <div class="detail">{{errorHandle(cashDis(receiptData?.signatureDetails?.discLabel))}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.txnDetails?.cashDiscount) | currency}}</div>
              </div>
              <div class="paymentDetails bold " *ngIf="itemizedDetails.totalDiscount">
                <div class="detail">Discount </div>
                <div class="detail"></div>
                <div class="detail"> ({{itemizedDetails.totalDiscount | toDollars}})</div>
              </div>
              <div class="paymentDetails bold " *ngIf="false else totalAmt">
                <div class="detail">{{'Total' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{itemizedDetails.totalAmount | toDollars}}</div>
              </div>
              <ng-template #totalAmt>
                <span
                  *ngIf="receiptData?.signatureDetails?.customField?.posType != 'TapOnPhone' && receiptData?.txnDetails.txName != 'BALANCE INQUIRY'">
                  <div
                    *ngIf="((receiptData?.txnDetails.totalAmount != receiptData?.txnDetails.txAmount ||  isFeeOrTaxEnabledShowTotalAmount(receiptData?.txnDetails)) && receiptData?.txnDetails.transactionType != 'LOYALTY' && getFeeDetails(receiptData?.feeDetails, receiptData?.txnDetails)) && !(receiptData?.txnDetails.txName == 'PREAUTH' && receiptData?.txnDetails.voidFlag == 'Y')"
                    class="paymentDetails bold">
                    <div class="detail" *ngIf="receiptData?.txnDetails?.txName != 'BALANCE INQUIRY'">{{totalPaidLabel
                      |
                      translate}}</div>
                    <div class="detail"></div>
                    <div class="detail"><span *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone'">USD</span>
                      {{transAmount(receiptData?.txnDetails?.totalAmount) | currency}}</div>
                  </div>
                </span>
                
                <span
                  *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone' && receiptData?.txnDetails.txName != 'BALANCE INQUIRY'">
                  <div
                    *ngIf="(receiptData?.txnDetails.transactionType != 'LOYALTY' && getFeeDetails(receiptData?.feeDetails, receiptData?.txnDetails)) && !(receiptData?.txnDetails.txName == 'PREAUTH' && receiptData?.txnDetails.voidFlag == 'Y')"
                    class="paymentDetails bold">
                    <div class="detail">{{'htmlText.total' | translate}}:</div>
                    <div class="detail"></div>
                    <div class="detail"><span>USD</span> {{transAmount(receiptData?.txnDetails?.totalAmount) |
                      currency}}
                    </div>
                  </div>
                </span>
              </ng-template>
              <div class="transactionDetailsResp" *ngIf="receiptData?.txnDetails.transactionType != 'CASH'">
                <div [ngClass]="isCheckTrans ? 'checkDetail' : 'detail'">{{'htmlText.resp' | translate}}:</div>
                <div [ngClass]="isCheckTrans ? 'checkDetail' : 'detail'">{{isApproval(receiptData?.txnDetails?.hostResponseCode)}}</div>
                <div *ngIf="isNotCheckTrans" class="detail">{{receiptData?.txnDetails?.hostResponseCode}}</div>
              </div>
              <div class="transactionDetailsCode"
                *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'WALLET'">
                <div [ngClass]="isCheckTrans ? 'checkDetail' : 'detail'">{{'htmlText.code' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail" *ngIf="isNotCheckTrans">{{errorHandle(receiptData?.txnDetails?.approvalCode)}}</div>
                <div class="checkDetail" *ngIf="isCheckTrans">{{isApproval(receiptData?.txnDetails?.approvalCode)}}</div>
              </div>
              <div class="transactionDetailsCode"
                *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'WALLET' && receiptData?.txnDetails.transactionType != transactionDetails.check">
                <div class="detail">{{'htmlText.ref' | translate}} #:</div>
                <div class="detail"></div>
                <div class="detail">{{errorHandle(receiptData?.txnDetails?.rrn)}}</div>
              </div>
              <div *ngIf="receiptData?.txnDetails?.tsysRespData?.SnfNumber" class="transactionDetailsCode">
                <div class="detail"*ngIf="receiptData?.txnDetails?.tsysRespData?.SnfNumber != ''" > {{'htmlText.offlineRef' | translate}} #:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.txnDetails?.tsysRespData?.SnfNumber}}</div>
              </div>
              <div class="transactionDetailsCode"
                *ngIf="receiptData?.txnDetails?.tsysRespData?.controlNumber && receiptData?.txnDetails?.tsysRespData?.controlNumber!='' && receiptData?.txnDetails?.tsysRespData?.controlNumber!=null">
                <div class="detail">{{'Fiscal Ctrl' | translate}} #:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.txnDetails?.tsysRespData?.controlNumber}}</div>
              </div>
              <div class="transactionDetails" *ngIf="receiptData?.signatureDetails?.customField?.loyalty?.discountApplied"> 
                <div class="detail discount">{{'htmlText.discountApplied' | translate}}:</div> 
                <div class="detail"></div> 
                <div class="detail bold">{{ transAmount(discount) | currency }}</div>
              </div> 
              <div class="rewardMessage mb-1">
                <div class="detail message-content" *ngIf="message1 != null && message1 != ''">
                    {{ message1}}
                </div>
                <div class="detail message-content" *ngIf="message2 != null && message2 != ''">
                  {{ message2}}
                </div>
                <div class="detail message-content" *ngIf="message3 != null && message3 != ''">
                  {{ message3}}
                </div>
              </div>
              <div class="transactionDetailsCode" *ngIf="receiptData?.txnDetails?.tsysRespData?.processedBy">
                <p>{{receiptData?.txnDetails?.tsysRespData?.processedBy}}</p>
              </div>
              <div class="transactionDetailsCode" *ngIf="receiptData?.txnDetails.txName == 'BALANCE INQUIRY'">
                <div class="detail">{{'htmlText.balance' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.txnDetails?.totalAmount) | currency}}</div>
              </div>
              <div *ngIf="((receiptData?.txnDetails?.txName === 'SALE' && receiptData?.txnDetails?.voidFlag ==
                    'N') || receiptData?.txnDetails?.txName === 'PREAUTH' || receiptData?.txnDetails?.txName === 'REFUND')"
                class="transactionDetailsCode">
                <div class="detail"
                  *ngIf="receiptData?.txnDetails?.tsysRespData?.TxId && receiptData?.txnDetails?.tsysRespData?.TxId != ''">
                  TransId:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.txnDetails?.tsysRespData?.TxId}}</div>
              </div>
              <div class="transactionDetailsCode"
                *ngIf="['CASH','WALLET', 'EBT'].indexOf(receiptData?.txnDetails.transactionType) < 0  && receiptData?.signatureDetails?.customField?.giftBalAmt">
                <div class="detail">{{'htmlText.balance' | translate}} </div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.signatureDetails?.customField?.giftBalAmt) | currency
                  }}
                </div>
              </div>
              <div class="transactionDetailsCode"
                *ngIf="receiptData?.txnDetails.transactionType == 'EBT' && receiptData?.signatureDetails?.customField?.giftBalAmt">
                <div class="detail">{{'htmlText.foodBalance' | translate}} </div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.signatureDetails?.customField?.giftBalAmt) | currency
                  }}
                </div>
              </div>
              <div class="transactionDetailsCode mb-1"
                *ngIf="receiptData?.txnDetails.transactionType == 'EBT' && receiptData?.signatureDetails?.customField?.ebtCashBalance">
                <div class="detail">{{'htmlText.cashBalance' | translate}} </div>
                <div class="detail"></div>
                <div class="detail">{{transAmount(receiptData?.signatureDetails?.customField?.ebtCashBalance) |
                  currency
                  }}</div>
              </div>
              <div *ngIf="receiptData?.signatureDetails?.customField?.appName" class="transactionDetailsCode">
                <div class="detail" *ngIf="receiptData?.signatureDetails?.customField?.appName != ''">App Name:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.signatureDetails?.customField?.appName}}</div>
              </div>
              <div *ngIf="receiptData?.signatureDetails?.customField?.aid" class="transactionDetailsCode">
                <div class="detail" *ngIf="receiptData?.signatureDetails?.customField?.aid != ''">AID:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.signatureDetails?.customField?.aid}}</div>
              </div>
              <div *ngIf="receiptData?.signatureDetails?.customField?.tvr" class="transactionDetailsCode">
                <div class="detail" *ngIf="receiptData?.signatureDetails?.customField?.tvr != ''">TVR:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.signatureDetails?.customField?.tvr}}</div>
              </div>
              <div *ngIf="receiptData?.signatureDetails?.customField?.tsi" class="transactionDetailsCode">
                <div class="detail" *ngIf="receiptData?.signatureDetails?.customField?.tsi != ''">TSI:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.signatureDetails?.customField?.tsi}}</div>
              </div>
             
              <!-- testing -->
            
              <div *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone'" class="transactionDetailsCode">
                <div class="detail" *ngIf="getEmv(receiptData?.txnDetails?.emvTags) != ''">TC:</div>
                <div class="detail"></div>
                <div class="detail">{{getEmv(receiptData?.txnDetails?.emvTags)}}</div>
              </div>
            
              <div class="transactionDetails" style="padding-top: 10px;" *ngIf="receiptData?.signatureDetails?.customField?.PaymentSettlingMessage">
                <div class="detail">{{'htmlText.type' | translate}}:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.signatureDetails?.customField?.PaymentSettlingVendor ? receiptData?.signatureDetails?.customField?.PaymentSettlingVendor : "Fortellis"}}</div>
              </div>
              <div *ngIf="receiptData?.signatureDetails?.customField?.PaymentSettlingMessage" class="transactionDetailsTrans">
                <div class="detail"
                  *ngIf="receiptData?.signatureDetails?.customField?.PaymentSettlingMessage && receiptData?.signatureDetails?.customField?.PaymentSettlingMessage != '' && receiptData?.signatureDetails?.customField?.PaymentSettlingVendor != 'Dominion'">
                  I-Ref#:</div>
                <div class="detail"
                  *ngIf="receiptData?.signatureDetails?.customField?.PaymentSettlingMessage && receiptData?.signatureDetails?.customField?.PaymentSettlingMessage != '' && receiptData?.signatureDetails?.customField?.PaymentSettlingVendor == 'Dominion'">
                  Dominion#:</div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.signatureDetails?.customField?.PaymentSettlingMessage}}</div>
              </div>
              <!-- commenting based on ios/top -->
              <!-- <div *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone'" class="transactionDetailsCode">
                <div class="detail" *ngIf="receiptData?.signatureDetails?.customField?.description != ''">DESCRIPTION:
                </div>
                <div class="detail"></div>
                <div class="detail">{{receiptData?.signatureDetails?.customField?.description}}</div>
              </div> -->
              <ng-container *ngIf="receiptData?.signatureDetails?.tagLabel && receiptData?.signatureDetails?.tagValue">
                <div class="transactionDetails" *ngFor="let item of receiptData?.signatureDetails?.tagLabel; let i=index; let last=last" [ngClass]="!last ?  'mb-0': 'mb-2'">
                  <div >{{item}} :</div>
                  <div >{{receiptData?.signatureDetails?.tagValue[i]}}</div>
                </div>
              </ng-container>
              <div class="transactionDetails" *ngIf="receiptData?.txnDetails?.tsysRespData?.PONumber && receiptData?.txnDetails?.tsysRespData?.PONumber !='' && receiptData?.txnDetails?.tsysRespData?.PONumber != null && receiptType =='Merchant Copy'">
                <div *ngIf="!receiptData?.signatureDetails?.customField?.poNumberLabel || receiptData?.signatureDetails?.customField?.poNumberLabel == null || receiptData?.signatureDetails?.customField?.poNumberLabel == ''">{{'poNumber' | translate}}:</div>
                <div *ngIf="receiptData?.signatureDetails?.customField?.poNumberLabel && receiptData?.signatureDetails?.customField?.poNumberLabel != null && receiptData?.signatureDetails?.customField?.poNumberLabel != ''">
                  {{receiptData?.signatureDetails?.customField?.poNumberLabel}}:
                </div>
                <div></div>
                <div>{{receiptData?.txnDetails?.tsysRespData?.PONumber}}</div>
              </div>

              <div class="transactionDetails" *ngIf="showMerchantRentalAgreementLine()">
                <div class="detail">Rental Agr #&nbsp;&nbsp;:</div>
                <div class="detail"></div>
                <div class="detail detail-rental-agr-ref">{{ formatMerchantRentalAgreementRefForReceipt() }}</div>
              </div>
    
              <h6 class="center mt-2"
                *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone' && receiptData?.signatureDetails?.customField?.verficationLine1 != ''">
                {{receiptData?.signatureDetails?.customField?.verficationLine1}}</h6>
              <h6 class="center mt-2"
                *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone' && receiptData?.signatureDetails?.customField?.verificationLine2 != ''">
                {{receiptData?.signatureDetails?.customField?.verificationLine2}}</h6>
            
              <!-- testing -->
            
              <!-- <div class="transactionDetailsApp">
                            <div class="detail">APP Name:</div>
                            <div class="detail"></div>
                            <div class="detail">{{isBrandName(receiptData?.txnDetails.maskedPan)}}</div>
                          </div>
                          <div class="transactionDetailsAid">
                            <div class="detail">AID:</div>
                            <div class="detail"></div>
                            <div class="detail">A000000003101001</div>
                          </div>
                          <div class="transactionDetailsTvr">
                            <div class="detail">TVR:</div>
                            <div class="detail"></div>
                            <div class="detail">0000000000</div>
                          </div> -->
              <!-- <div class="transactionDetailsTvr">
                            <div class="detail">TSI:</div>
                            <div class="detail"></div>
                            <div class="detail">E45RDF</div>
                          </div> -->
              <p *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'WALLET' && isNotCheckTrans"
                class="center agree description-break">{{errorHandle(receiptData?.receiptDetails?.DIS)}}
              </p>
              <h6 class="center mx-2 font-weight-normal"
                *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.signatureDetails?.customField?.savingsMsgLabel && receiptType!='Merchant Copy'" >
                {{receiptData?.signatureDetails?.customField?.savingsMsgLabel}}</h6>
              <!-- testing -->
              <span *ngIf="receiptData?.signatureDetails?.customField?.posType != 'TapOnPhone'">
                <p class="center font-weight-bold"
                  *ngIf="(receiptData?.txnDetails?.pinBlock != 0 || receiptData?.txnDetails?.pinBlock != 'XXXXXXXXXXXXXXXX' || receiptData?.txnDetails?.pinBlock != 'NOCVM') && receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET'  && receiptData?.txnDetails.transactionType != transactionDetails.check">
                  {{pinBlock(receiptData?.txnDetails?.pinBlock)}}</p>
              </span>
            
            
              <!-- testing -->
              <span *ngIf="receiptData?.signatureDetails?.customField?.posType != 'TapOnPhone' &&  !receiptData?.signatureDetails?.customField?.signature">
                <div *ngIf="(receiptData.signatureDetails != null && receiptData.signatureDetails.signImage)" class="logo">
                  <img style="width: 100px;" src="{{baseUrl}}/{{receiptData?.signatureDetails?.signImage}}">
                </div>
                <div *ngIf="(receiptData.signatureDetails == null || receiptData.signatureDetails.signImage == null)" class="logo">
                  <img class="img_align"></div>
            
                <span *ngIf="(receiptData?.txnDetails?.pinBlock == '0')">
                  <hr
                    *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET'"
                    class="hr_align">
                </span>
            
                <span *ngIf="(receiptData?.txnDetails?.pinBlock == '0')">
                  <p *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET'"
                    class="sign font-weight-bold mb-3">Signature</p>
                </span>
            
                <!-- <p class="sign font-weight-bold mb-3" *ngIf="(!receiptData?.signatureDetails?.chName)">Signature</p> -->
                <!-- <p class="sign font-weight-bold mb-1" *ngIf="(receiptData?.signatureDetails?.chName)">Cardholder Name</p> -->
                <p *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET'"
                  class="center">{{cardholderName(receiptData?.signatureDetails?.chName)}}</p>
              </span>
            
              <span
                *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone' && receiptData?.signatureDetails?.customField?.verficationLine1 == '' && receiptData?.signatureDetails?.customField?.verificationLine2 == ''">
                <div *ngIf="(receiptData.signatureDetails != null && receiptData.signatureDetails.signImage)" class="logo">
                  <img style="width: 100px;" src="{{baseUrl}}/{{receiptData?.signatureDetails?.signImage}}">
                </div>
                <div *ngIf="(receiptData.signatureDetails == null || receiptData.signatureDetails.signImage == null)" class="logo">
                  <img class="img_align"></div>
            
                <span>
                  <hr
                    *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET'"
                    class="hr_align">
                </span>
            
                <span>
                  <p *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET'"
                    class="sign font-weight-bold mb-3" class="sign font-weight-bold mb-3">Signature</p>
                </span>
            
                <!-- <p class="sign font-weight-bold mb-3" *ngIf="(!receiptData?.signatureDetails?.chName)">Signature</p> -->
                <!-- <p class="sign font-weight-bold mb-1" *ngIf="(receiptData?.signatureDetails?.chName)">Cardholder Name</p> -->
                <p *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET'"
                  class="center">{{cardholderName(receiptData?.signatureDetails?.chName)}}</p>
              </span>
             
              <!--e-signature-cloud-POS-->
               <span  *ngIf="receiptData?.signatureDetails?.customField?.posType != 'TapOnPhone' && receiptData?.signatureDetails?.customField?.signature?.eSignature">
                <span class="fw-bold d-block text-center mt-4"> {{receiptData?.signatureDetails?.customField?.signature?.eSignature}}</span>
                  <hr class="m-1">
                <span>
                  <p class="sign font-weight-bold mb-4" >E-Signature</p>
                </span>
                 <p *ngIf="receiptData?.txnDetails.transactionType != 'CASH' && receiptData?.txnDetails.transactionType != 'GIFT' && receiptData?.txnDetails.transactionType != 'LOYALTY' && receiptData?.txnDetails.transactionType != 'WALLET'" class="center mb-1">{{cardholderName(receiptData?.signatureDetails?.chName)}}</p>
              </span>

              <!--e-sign-cloudpos-end-->
            
              <!-- testing -->
            
              <h6 class="center mt-2" *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone'">
                {{receiptData?.signatureDetails?.customField?.refundPolicy1}}</h6>
              <h6 class="center mt-2" *ngIf="receiptData?.signatureDetails?.customField?.posType == 'TapOnPhone'">
                {{receiptData?.signatureDetails?.customField?.refundPolicy2}}</h6>
            
              <h6 class="center mt-2 font-weight-normal"
                *ngIf="receiptData?.txnDetails.transactionType == 'CASH' && receiptData?.signatureDetails?.customField?.savingsMsgLabel && receiptType!='Merchant Copy'">
                {{receiptData?.signatureDetails?.customField?.savingsMsgLabel}}</h6>
            
              <!-- testing -->
            
            
            
              <h6 class="center mt-2">{{receiptType?receiptType:types.CC}}</h6>
              <div *ngIf="receiptType!='Merchant Copy'">
                <h6 class="center mt-2 word-break">{{errorHandleF(receiptData?.receiptDetails?.f1)}}</h6>
                <h6 class="center mt-2 word-break">{{errorHandleF(receiptData?.receiptDetails?.f2)}}</h6>
              </div>
                <hr class="mt-1 mb-0">
            </section>
            <section *ngIf="isItemsList && isValidItemDetails()">
              <div *ngIf="logo" class="logo"><img class="logo_align" [src]="logo" alt="MERCHANTLOGO"></div>
              <div class="address">
                <p class="center_add pb-3">{{errorHandle(receiptData?.receiptDetails?.h1)}}</p>
                <!-- <p class="center_add">{{errorHandle(receiptData?.receiptDetails?.h2)}}</p>
                <p class="center_add">{{errorHandle(receiptData?.receiptDetails?.h3)}}</p>
                <p class="center_add">{{errorHandle(receiptData?.receiptDetails?.h4)}}</p> -->
                <p class="center_add"></p>
                <p class="center_add"></p>
              </div>
              
              <div class="survey bold dashed-border-top-bottom">
                <p class="txt_size_txname center_add">Items List</p>
              </div>
              <div class="transactionDetails dashed-border-bottom">
                <div class="detail">{{errorHandle(receiptData?.txnDetails?.posRequestDate | momentDate)}}</div>
                <div class="detail"></div>
                <div class="detail">{{errorHandle(timeSub(receiptData?.txnDetails?.posRequestTime))}}</div>
              </div>
              <div class="bold text-center">
                <p class="center_add pt-2">Item / Cash Price / Card Price</p>
                <span class="center_add">*****************************</span>
              </div>
              <div *ngIf="itemDetails?.itemList?.length>0">

                <div class="pb-2">
                  <ng-container *ngFor="let itemsList of itemDetails.itemList">
                    <p class="text-center pb-1">#{{itemsList.id}} / ${{itemsList.cashPrice}} / ${{itemsList.cardPrice}}</p>
                  </ng-container>    
                </div>
              
                <div class="bold dashed-border-top pt-2">
                  <p class="center_add">{{itemDetails?.count}} / ${{itemDetails?.cashTotal}} / ${{itemDetails?.cardTotal}}</p>
                </div>
                
                <div class="bold dashed-border-top pt-5">
                  <p class="center_add">Cash Discount : ${{itemDetails?.cashDiscount?itemDetails?.cashDiscount:'0.00'}}</p>
                </div>

              </div>
              
            </section>
            <section #promotionSection class="mt-3" *ngIf="isShowPromotion && receiptType!='Merchant Copy'">
              <a target="_blank" [href]="promotion.promotionalUrl" class="link-container text-center">
                <p class="text-center mb-2">
                  <strong> {{promotion.title}} </strong>
                </p>
                <!-- <img class="click-here" src="/assets/gif/clickhere.gif"> -->
                <picture class="picture-container gray-background">
                  <img [src]="promotion.promotionImageUrl" class="preview-img">
                </picture>
                <p class="text-center mt-2 text-break p-1">
                  {{promotion.message}}
                </p>
              </a>
            </section>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


 
<ng-template #openEmailPopup let-modal>

  <div class="modal-header d-flex justify-content-between p-3">
      <div class="ml-2">
        <h5 class="modal-title" id="modal-basic-title"><span class="font-weight-bold title-text">Email To</span>
        </h5>
      </div>
  </div>

  <div class="modal-body text-center px-5 py-5" >
    <form [formGroup]="receiptsendform">
      <div class="form-group">
        <input type="text" formControlName="email" placeholder="Enter Email Address" class="form-control" maxlength="50"
          [ngClass]="{ 'is-invalid': isSubmitted && find.email.errors }" />
        <div *ngIf="isSubmitted && find.email.errors" class="alert normal-font">
          <div *ngIf="find.email.errors.required">Email is required</div>
          <div *ngIf="find.email.errors.pattern">Email must be a valid email address</div>
        </div>
      </div>
    </form>
  </div>
    
    <div class="card-footer pb-2 email-btn-font">
      <button class="mt-2 ml-2 text-right btn btn-primary float-right" [disabled]="find.email.status == 'INVALID' || isSubmitted" (click)="onSubmitForm()">
        <span *ngIf="isLoadingSpinner" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>  {{'htmlText.submit'| translate}}</button>
      <button (click)="modal.close()" class="mt-2 text-right btn btn-danger mr-2 float-right mb-2" >{{'htmlText.cancel'| translate}}</button>
    </div>
  

</ng-template>